import { createRouter, createWebHistory } from 'vue-router';
import LandingPage from '@/components/LandingPage.vue';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'LandingPage',
      component: LandingPage,
      meta: {
        title: 'Erdem Karataş — Engineer, Product Builder & Independent Maker',
        description: 'Portfolio of Erdem Karataş: product engineering, quality automation, independent web products, games and academic work.'
      }
    }
  ],
  scrollBehavior(to) {
    if (to.hash) return { el: to.hash, behavior: 'smooth' };
    return { top: 0 };
  }
});

router.afterEach((to) => {
  document.title = to.meta.title || 'Erdem Karataş';
  const description = document.querySelector('meta[name="description"]');
  if (description && to.meta.description) description.setAttribute('content', to.meta.description);
});

export default router;
